import { getGridNumericOperators, GridColDef } from '@mui/x-data-grid';
import { ProductionStepDetails } from 'benchmarking-domain/normalization/normalization-details';
import { nameOf } from 'helpers/nameof';
import { NumberHelper } from 'helpers/number';

const RoundingPrecision = 4;

const numberColumnCommon: Partial<GridColDef<ProductionStepDetails>> = {
  minWidth: 150,
  flex: 1,
  align: 'right',
  filterOperators: getGridNumericOperators(),
  valueFormatter: (v) => NumberHelper.formatNumber(v, RoundingPrecision),
};

export const NormalizationGridColumns: GridColDef<ProductionStepDetails>[] = [
  {
    field: nameOf<ProductionStepDetails>('variable'),
    headerName: 'Variable',
    flex: 2,
    minWidth: 200,
  },
  {
    ...numberColumnCommon,
    field: nameOf<ProductionStepDetails>('volume'),
    headerName: 'Volume [Unit]',
  },
  {
    ...numberColumnCommon,
    field: nameOf<ProductionStepDetails>('cost'),
    headerName: 'Cost [USD (United States of America)]',
  },
  {
    ...numberColumnCommon,
    field: nameOf<ProductionStepDetails>('headcount'),
    headerName: 'Headcount [FTE]',
  },
  {
    ...numberColumnCommon,
    field: nameOf<ProductionStepDetails>('costConversionFactor'),
    headerName: 'Cost conversion factor',
  },
  {
    ...numberColumnCommon,
    field: nameOf<ProductionStepDetails>('headcountConversionFactor'),
    headerName: 'Headcount conversion factor',
  },
  {
    ...numberColumnCommon,
    field: nameOf<ProductionStepDetails>('cnu'),
    headerName: 'CNU (Production)',
  },
  {
    ...numberColumnCommon,
    field: nameOf<ProductionStepDetails>('pnu'),
    headerName: 'PNU (Production)',
  },
  {
    ...numberColumnCommon,
    field: nameOf<ProductionStepDetails>('normalizedCost'),
    headerName: 'Normalized cost [USD / CNU (Production)]',
  },
  {
    ...numberColumnCommon,
    field: nameOf<ProductionStepDetails>('normalizedProductivity'),
    headerName: 'Normalized productivity [PNU (Production) / Headcount]',
  },
];
